import Api from "../../Api";
import { modifyError } from "../../Validation/ModifyErrros";

export const getDrsInstance = async (query) => {
  try {
    let res = await Api.get("/drsshipinstance", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getDrsInstanceById = async (id) => {
  try {
    let res = await Api.get("/drsshipinstance/" + id);

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const createDrsInstance = async (data) => {
  try {
    let res = await Api.post("/drsshipinstance", data);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const updateDrsInstance = async (id, data) => {
  try {
    let res = await Api.patch("/drsshipinstance/" + id, data);

    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const deleteDrsInstance = async (id) => {
  try {
    let res = await Api.delete("/drsshipinstance/" + id);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};
